var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25605 5.35742L2.84384 7.55104L2.03902 10.8494C1.88092 11.4647 2.5598 11.9696 3.11185 11.6226L5.9998 9.83899L8.88765 11.6223C9.42434 11.9534 10.1027 11.4645 9.96059 10.849L9.15566 7.55093L11.7438 5.3572C12.2326 4.947 11.9803 4.14219 11.3335 4.09479L7.94053 3.84213L6.66244 0.702073C6.4258 0.118207 5.58938 0.118207 5.33672 0.702073L4.05863 3.84224L0.665798 4.0949C0.0192993 4.15832 -0.233362 4.94723 0.25605 5.35742Z",
    fill: "#FFB300",
    stroke: "#FFB300",
    strokeWidth: 0.597572
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellow_star.43cbae2fd4b7a3e2634084dbd0fc967c.svg";
export { ForwardRef as ReactComponent };